module.exports = __webpack_public_path__ + "img/ring_y_e_0_1@3x.82155d9b.png";